module.exports = __webpack_public_path__ + "img/mtn.60e91db7.png";